import React from 'react'
import injectSheet from 'react-jss'
import Arrow from '../../icons/arrowIcon'

const arrowButton = (props) => {
  const {
    classes,
    onClick,
    direction,
    disabled,
  } = props

  return (
    <button
      className={`${classes.arrowButton} ${direction} ${disabled && 'disabled'}`}
      onClick={onClick}
      disabled={disabled}
    >
      <Arrow />
    </button>
  )
}

const styles = theme => ({
  arrowButton: {
    width: '30px',
    height: '30px',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    [theme.media.medium]: {
      width: '50px',
      height: '50px',
    },
    [theme.media.large]: {
      width: '70px',
      height: '70px',
    },
    '>svg': {
      fill: theme.colors.secondary_3b,
      height: '100%',
    },
    '&.left>svg': {
      transform: 'rotate(180deg)',
    },
    '&.disabled>svg': {
      fill: theme.colors.main_3,
    },
  },
})

export default injectSheet(styles)(arrowButton)



// WEBPACK FOOTER //
// ./src/modules/core/components/arrowButton.jsx